import apiRequest from '@/http/api-request'
import authService from '@/auth/authService'
import {prepareDonationParams} from "@/utils/utils";

export default {

  fetchAllDonations({commit, state}, {charityId}) {

    if (state.donationsState === 'loading') {
      return new Promise((resolve) => resolve(state.donations));
    }

    commit('LOADING_DONATIONS');

    return new Promise((resolve, reject) => {
      return apiRequest.doGetRequest(`/data/${charityId}/roundups/combined`, {},
        {'X-Harness-JWT': authService.getToken()}, {skipCache: true, returnParam: 'accounts'})
        .then(donations => {
          commit('SET_DONATIONS', donations);
          resolve(donations);
        })
        .catch((error) => reject(error));
    });
  },
  editDonation({commit}, {charityId, accountId, params, accountType}) {
    params = prepareDonationParams(params);

    return new Promise((resolve, reject) => {
      if (accountType === 'cardLinked') {

        let paramsR = new URLSearchParams();
        paramsR.append('campaign_id', params.campaign_id);
        paramsR.append('rounding', params.rounding);
        paramsR.append('max_cap', params.max_cap);

        return apiRequest.doPutRequest(`/charity/${charityId}/card/roundup/${accountId}`, paramsR)
          .then(result => {
            if (params.hasOwnProperty('campaign_id')) {
              commit('EDIT_DONATION', {
                id: accountId,
                campaign_id: params.campaign_id,
                campaignId: params.campaign_id,
              })
            }
            resolve(result)
          })
          .catch((error) => reject(error));
      }
      else{
        return apiRequest.doPatchRequest(
          `/charity/${charityId}/roundup/${accountId}`, 
          params,
          { 'Content-Type': 'application/json' },
        )
          .then(result => {
            if (params.hasOwnProperty('campaign_id')) {
              commit('EDIT_DONATION', {
                id: accountId,
                campaign_id: params.campaign_id,
                campaignId: params.campaign_id,
              })
            }
            resolve(result)
          })
          .catch((error) => reject(error));
      }

    })
  },
  cancelDonation({commit}, {charityId, accountId, accountType}) {
    return new Promise((resolve, reject) => {
      if (accountType === 'cardLinked') {
        return apiRequest.doDeleteRequest(`/charity/${charityId}/card/roundup/${accountId}`)
          .then(result => {
            commit('REMOVE_DONATION', accountId);
            resolve(result)
          })
          .catch((error) => reject(error));
      } else {
        return apiRequest.doDeleteRequest(`/charity/${charityId}/roundup/${accountId}`)
          .then(result => {
            commit('REMOVE_DONATION', accountId);
            resolve(result)
          })
          .catch((error) => reject(error));
      }
    })
  }
}
